// services/visitStatus.ts — SKIN-543: close / reopen a visit from the web; SKIN-696: void a DRAFT one.
import axios from 'axios';
import { OtherOpenDraft, VisitStatusChange } from '../pages/hospital/patient/visitStatusChange';

const VISITS_BASE_URL = import.meta.env.VITE_APP_API_URL + '/visits';

/**
 * PATCH /visits/investigation/:inv/visit/:visit/web/{close,reopen,void} with `{ reason }`.
 * The path segment is the `change`, so a new action needs no change here. Rejects with the
 * AxiosError on refusal; `response.data` carries the API's `error` code (and
 * `missingRequiredFields` for a close), which VisitStatusAction decodes.
 */
export async function changeVisitStatusFromWeb(
    uuidInvestigation: string,
    uuidVisit: string,
    change: VisitStatusChange,
    reason: string,
): Promise<unknown> {
    const url = `${VISITS_BASE_URL}/investigation/${uuidInvestigation}/visit/${uuidVisit}/web/${change}`;
    const response = await axios.patch(url, { reason }, { headers: { Authorization: localStorage.getItem('jwt') ?? '' } });
    return response.data;
}

/**
 * GET /visits/investigation/:inv/visit/:visit/web/reopen-check — the visit author's OTHER
 * open (Draft) visits on the same case, oldest first. Read by the reopen dialog to warn;
 * the reviewer usually cannot see those drafts in the visit list (CLINICAL hides them).
 */
export async function fetchOtherOpenDrafts(uuidInvestigation: string, uuidVisit: string): Promise<OtherOpenDraft[]> {
    const url = `${VISITS_BASE_URL}/investigation/${uuidInvestigation}/visit/${uuidVisit}/web/reopen-check`;
    const response = await axios.get(url, { headers: { Authorization: localStorage.getItem('jwt') ?? '' } });
    const drafts = response.data?.otherDrafts;
    // A shape we do not recognise is a failed check, not "no other draft".
    if (!Array.isArray(drafts)) throw new Error('reopen-check: unexpected response');
    return drafts;
}
